export default "__VITE_ASSET__DcSfslZi__"